import {
    ADD_P24_MERCHANT,
    EDIT_P24_MERCHANT,
    DELETE_P24_MERCHANT,
    FETCH_P24_MERCHANTS,
    FETCH_P24_MERCHANT_BY_ID,
    TEST_CONNECTION_P24_MERCHANT,
    FETCH_P24_MERCHANT_PAYMENT_METHODS,
    FETCH_P24_MERCHANTS_BY_NIP,
    FETCH_P24_MERCHANTS_BY_PESEL,
    FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID

} from "./actionTypes";

import axios from "axios";
import {
    infoAddToast,
    infoEditToast,
    infoDeleteToast
} from "../components/Toast";
import {
    P24_MERCHANTS_URL,
    P24_MERCHANTS_BY_ID_URL,
    P24_MERCHANTS_BY_NIP_URL,
    P24_MERCHANTS_BY_PESEL_URL,
    P24_MERCHANTS_BY_P24_MERCHANT_ID_URL,
    P24_MERCHANT_TEST_CONNECTION_URL,
    P24_MERCHANT_PAYMENT_METHODS_URL
} from "../../config"

/**
 * Pobieranie listy merchantow p24 z serwera
 */
export const fetchP24Merchants = () => {
    return dispatch => {
        return axios
            .get(P24_MERCHANTS_URL)
            .then(response => {
                dispatch(fetchP24MerchantsSuccess(response.data));
            })
    }
}

/**
 * Pobieranie merchanta p24 z serwera dla podanego id
 * 
 * @param {int} merchantId  identyfikator merchanta do pobrania
 */
export const fetchP24MerchantById = (merchantId) => {
    return dispatch => {
        return axios
            .get(P24_MERCHANTS_BY_ID_URL(merchantId))
            .then(response => {
                dispatch(fetchP24MerchantsByIdSuccess(response.data));
            })
    }
}

/**
 * Tworzenie merchanta na serwerze
 *
 * @param {object} merchant obiekt merchanta do stworzenia
 */
export const createMerchant = (merchant) => {
    return dispatch => {
        return axios
            .post(`${P24_MERCHANTS_URL}`, JSON.stringify(merchant), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(createMerchantSuccess(response.data));
                infoAddToast();
            });
    };
};

/**
 * Aktualizacja merchanta na serwerze
 * 
 * @param {object} merchant obiekt merchanta do stworzenia
 */
export const updateMerchant = (merchant) => {
    return dispatch => {
        return axios
            .put(`${P24_MERCHANTS_URL}/${merchant.id}`, JSON.stringify(merchant), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(updateMerchantSuccess(response.data));
                infoEditToast();
            });
    };
};

/**
 * Aktualizacja danych autoryzacyjnych merchanta na serwerze - api key
 * 
 * @param {object} merchantAuth obiekt merchanta do aktualizacji
 */
export const updateMerchantAuthApiKey = (merchantAuth) => {
    return dispatch => {
        return axios
            .post(`${P24_MERCHANTS_URL}/${merchantAuth.id}/authApiKey`, JSON.stringify(merchantAuth), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                infoEditToast();
            });
    };
};

/**
 * Aktualizacja danych autoryzacyjnych merchanta na serwerze - crc key
 * 
 * @param {object} merchantAuth obiekt merchanta do aktualizacji
 */
export const updateMerchantAuthCrcKey = (merchantAuth) => {
    return dispatch => {
        return axios
            .post(`${P24_MERCHANTS_URL}/${merchantAuth.id}/authCrcKey`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                infoEditToast();
            });
    };
};

/**
 * Aktualizacja danych autoryzacyjnych merchanta na serwerze - sandbox crc key
 * 
 * @param {object} merchantAuth obiekt merchanta do aktualizacji
 */
export const updateMerchantAuthSandboxCrcKey = (merchantAuth) => {
    return dispatch => {
        return axios
            .post(`${P24_MERCHANTS_URL}/${merchantAuth.id}/authSandboxCrcKey`, JSON.stringify(merchantAuth), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                infoEditToast();
            });
    };
};

/**
 * Kasowanie merchanta na serwerze
 * 
 * @param {object} merchant obiekt merchanta do skasowania
 */
export const deleteMerchant = (merchant) => {
    return dispatch => {
        return axios
            .delete(`${P24_MERCHANTS_URL}/${merchant.id}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(deleteMerchantSuccess(merchant.id));
                infoDeleteToast();
            });
    };
};

/**
 * Wyszukiwanie merchanata po nipie
 * 
 * @param {String} nip nip
 */
export const findP24MerchantsByNip = (nip) => {
    return dispatch => {
        return axios
            .get(P24_MERCHANTS_BY_NIP_URL(nip))
            .then(response => {
                dispatch(findP24MerchantsByNipSuccess(response.data));
            })
    }
}

/**
 * Wyszukiwanie merchanata po peselu
 * 
 * @param {String} pesel pesel
 */
export const findP24MerchantsByPesel = (pesel) => {
    return dispatch => {
        return axios
            .get(P24_MERCHANTS_BY_PESEL_URL(pesel))
            .then(response => {
                dispatch(findP24MerchantsByPeselSuccess(response.data));
            })
    }
}

/**
 * Wyszukiwanie merchanata po p24MerchantId
 * 
 * @param {Integer} p24MerchantId identyfikator merchanta p24
 */
export const findP24MerchantsByP24MerchantId = (p24MerchantId) => {
    return dispatch => {
        return axios
            .get(P24_MERCHANTS_BY_P24_MERCHANT_ID_URL(p24MerchantId))
            .then(response => {
                dispatch(findP24MerchantsByP24MerchantIdSuccess(response.data));
            })
    }
}

/**
 * Sprawdzanie połączenia dla podanego merchanta
 * 
 * @param {P24ImplementationType} p24ImplementationType typ implementacji
 * @param {*} marchantId identyfikator merchanta
 */
export const testConnectionP24Merchant = (p24ImplementationType, marchantId) => {
    return dispatch => {
        return axios
            //.get(P24_MERCHANT_TEST_CONNECTION_URL(marchantId))
            .get(P24_MERCHANT_TEST_CONNECTION_URL(marchantId), {
                params: {
                    implType: p24ImplementationType.id
                }
            }
            )
            .then(response => {
                dispatch(testConnectionP24MerchantSuccess(response.data));
            })
            
    }
}

/**
 * Pobieranie listy merchantow p24 z serwera
 */
export const fetchP24MerchantPaymentMethods = (type, marchantId) => {

    return dispatch => {
        return axios
            .get(P24_MERCHANT_PAYMENT_METHODS_URL(marchantId))
            .then(response => {
                dispatch(fetchP24MerchantPaymentMethodsSuccess(response.data));
            })
    }
}

/**
 * Akcja pomyślnego pobrania listy merchantow p24 
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const fetchP24MerchantsSuccess = data => {
    return {
        type: FETCH_P24_MERCHANTS,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania listy merchantow p24 
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const fetchP24MerchantsByIdSuccess = data => {
    return {
        type: FETCH_P24_MERCHANT_BY_ID,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania listy merchantow p24 dla podanego nipu
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const findP24MerchantsByNipSuccess = data => {
    return {
        type: FETCH_P24_MERCHANTS_BY_NIP,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania listy merchantow p24 dla podanego peselu
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const findP24MerchantsByPeselSuccess = data => {
    return {
        type: FETCH_P24_MERCHANTS_BY_PESEL,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania listy merchantow p24 dla podanego p24MerchantId
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const findP24MerchantsByP24MerchantIdSuccess = data => {
    return {
        type: FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania listy metod płatności dla konkretnego merchanta 
 * 
 * @param {object} data Obiekt pobranej listy metod płatności
 */
export const fetchP24MerchantPaymentMethodsSuccess = data => {
    return {
        type: FETCH_P24_MERCHANT_PAYMENT_METHODS,
        payload: data
    };
};

/**
 * Akcja pomyślnego utworzenia merchanta
 * 
 * @param {object} data object utworzonego merchanta
 */
export const createMerchantSuccess = data => {
    return {
        type: ADD_P24_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnej aktualizacji merchanta
 * 
 * @param {object} data object utworzonego merchanta
 */
export const updateMerchantSuccess = data => {
    return {
        type: EDIT_P24_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnego skasowania merchanta
 * 
 * @param {object} data 
 */
export const deleteMerchantSuccess = data => {
    return {
        type: DELETE_P24_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnego pobrania statusu połączenia dla podanego merchanta
 * 
 * @param {object} data Obiekt pobranej listy merchantow
 */
export const testConnectionP24MerchantSuccess = data => {
    return {
        type: TEST_CONNECTION_P24_MERCHANT,
        payload: data
    };
};